<template>
  <div class="shopsSon">
    <el-card class="box-card">
      <div slot="header" style="display: flex;flex-flow: column">
        <div style="display:flex;align-items: center">
          <i @click="onBack" class="el-icon-arrow-left" style="font-size:25px;"></i>
          <span style="font-size:25px;font-weight:bold;margin:0 10px;">{{ h_text }}</span>
        </div>
        <div style="display: flex;align-items: center;margin-top:20px">
          <p style="width:90px">商品分类</p>
          <el-select v-model="edi_type" ref='select5' clearable placeholder="商品类型"
                     style="width:8vw;margin-left:1px">
            <el-option v-for="(item,index) in liType" :key="item.value" :label="item.label" :value="item.value">
              <div class="option-content">
                <span class="option-label">{{ item.label }}</span>
                <!--                <i class="el-icon-delete delete-icon" @click.stop="typeDelete(index)"></i>-->
              </div>
            </el-option>
          </el-select>
          <!--          <el-button @click="onAddGoodsType" type="primary" style="margin-left:10px">新增分类</el-button>-->
        </div>
      </div>
      <div class="search-box">
        <span style="font-weight:bold;margin-top:10px">商品基本信息</span>
        <div style="display: flex;align-items:center;height:60px;margin-top:10px">
          <span style="color:red;margin-right:3px">*</span>
          <span style="width:80px">商品标题</span>
          <el-input v-model="name" placeholder="请输入" :maxlength="30" show-word-limit
                    style="margin-left:1px;width:20vw">
          </el-input>
        </div>
        <div style="display: flex;align-items:center;height:60px">
          <span style="color:red;margin-right:3px">*</span>
          <span style="width:80px">商品简介</span>
          <el-input v-model="brief" placeholder="请输入" :maxlength="30" show-word-limit
                    style="margin-left:1px;width:20vw">
          </el-input>
        </div>
        <div style="display:flex;align-items:center;height:60px;">
          <span style="color:red;margin-right:3px">*</span>
          <span style="width:80px">规格参数</span>
          <div style="width:60%;display:flex;align-items:center;">
            <span style="margin-left:1px;">使用产品库快捷添加商品基本信息，从此添加商品不再困扰!最大可添加6个规格</span>
            <el-button type="primary" @click="onAdd" style="margin-left:auto;margin-right:1px">新增规格</el-button>
          </div>
        </div>
        <el-table :data=fil_tabData2 class="tab_adb" :cell-style="tableYs" border
                  style="width:60%; margin-left:90px;font-size:13px; background:#FFFFFF;margin-top:1px"
                  show-overflow-tooltip
                  ref="multipleTable"
                  :header-cell-style="{ 'height': '30px', 'text-align': 'center', 'background': '#f4f4f4', 'color': '#0dA7C8' }">
          <el-table-column width="1">
          </el-table-column>
          <div v-for="(d, item) in this.defHead1">
            <el-table-column v-if="d.val === 'skuName' || d.val === 'skuCode'" :label=d.key :width="d.w">
              <template slot-scope="scope">
                <el-input v-model="scope.row[d.val]" :controls="false"
                          style="color:#72767b;font-size: 16px;width:80%"/>
              </template>
            </el-table-column>
            <el-table-column v-else :label=d.key :width="d.w">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row[d.val]" :controls="false"
                                 style="color:#72767b;font-size: 16px;width:80%"/>
              </template>
            </el-table-column>
          </div>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="onDel(scope.$index)" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
        <div style="display:flex;align-items:center;height:60px;width:60%">
          <span style="color:red;margin-right:3px">*</span>
          <span style="width:80px">商品图片</span>
          <span style="margin-left:1px;">上传图片的最佳尺寸：720像素*720像素</span>
        </div>
        <div style="display:flex;align-items:center;padding-left:90px">
          <div style="width:10vw">
            <p style="margin-top:5px;">主图</p>
            <el-upload class="avatar-uploader" :action=url_upFile :show-file-list="false"
                       :before-upload="beforeAvatarUpload"
                       :on-success="handleAvatarSuccess">
              <el-image :src="imageUrl" key="fit" style="width:8vw;height:8vw;margin-top:5px">
                <div slot="error"
                     style="background-color:#F4F4F4;font-size:25px;height:100%;width:100%;display:flex;align-items:center;justify-content: center">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-image>
            </el-upload>
          </div>
          <div style="width:50vw;display:flex;flex-flow: column;justify-items: center">
            <p style="margin-top:5px;">详情图（{{ liImg.length }}/4）</p>
            <div style="display:flex;align-items:center">
              <div v-for="(d,index) in liImg" style="position:relative;display: inline-block;">
                <el-image :src="d.url" :key="index" class="target-image"
                          style="width:8vw;height:8vw;margin-right:10px;margin-top:5px">
                  <div slot="error" style="background-color:#F4F4F4;height:100%;width:100%">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div style="position:absolute;top:-10px;right:0;">
                  <el-button icon="el-icon-close" size="mini" circle @click="handleDelete(index)"></el-button>
                </div>
              </div>
              <el-upload :action=url_upFile :show-file-list="false" :on-success="handleAvatarSuccess"
                         :before-upload="beforeFile1" style="height:2px">
                <p ref="upload1" v-show=false style="line-height:1px;height:1px;width:1px"/>
              </el-upload>
              <div @click="handleUpload1" style="background-color:#F4F4F4;font-size:25px;width:8vw;height:8vw;
                   display:flex;align-items:center;justify-content: center">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;align-items:self-start;margin-top:10px">
          <span style="color:red;margin-right:3px">*</span>
          <span style="width:80px">商品描述</span>
          <div style="width:60%;display:flex;align-items:center;">
            <quill-editor ref="myQuillEditor" v-model="description" :options="editorOption" @blur="onEditorBlur()"
                          @focus="onEditorFocus()" @ready="onEditorReady()" @change="onEditorChange()"/>
          </div>
        </div>
      </div>
      <div style="display: flex;align-items: center">
        <el-button @click="onBack" style="margin-left:auto">取消</el-button>
        <el-button @click="keepData" type="primary" style="margin-left:20px;margin-right:20px">{{ txt_keep }}
        </el-button>
      </div>
    </el-card>
    <el-dialog title="新增商品分类" center :close-on-click-modal="false"
               width="360px" class="dialog_daiAddDev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiGoodsType'> <!--v-draggable 拖动-->
      <div style="display:flex;margin-bottom:10px;height:50px;width:100%;line-height:0.3;
        text-align:left;align-items:center;">
        <span style="margin-left:0px; width:80px; color: #000000; font-size: 13px">
            类型名称：
        </span>
        <el-input style="margin-left:1px; width: 200px;; color: #000000; font-size: 13px"
                  v-model="edi_typeName">
        </el-input>
      </div>
      <div style="display:flex;margin-bottom:10px;height:50px;width:100%;line-height:0.3;
        text-align:left;align-items:center;">
        <span style="margin-left:0px; width:80px; color: #000000; font-size: 13px">
            类型排序：
        </span>
        <el-input-number size="medium" v-model="edi_typeSort"
                         style="margin-left:1px;width:200px;"
                         :precision="0" :step="1" :min="1" :max="10000">
        </el-input-number>
      </div>
      <div slot="footer" style="display: flex;align-items: center">
        <el-button @click="daiGoodsType = false" style="margin-left: auto">取 消</el-button>
        <el-button type="primary" @click="keepType" style="margin-left: 10px;margin-right: 10px">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog top="2vh" width="60vw" title="图片裁剪" :show-close="true" :visible.sync="dialogVisible"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="cropper-w" style="margin:0">
        <div class="cropper" :style="{textAlign:'center',height: img_h }">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"
                      :info="option.info" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
                      :original="option.original" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
                      :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox">
          </vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import vueCropper from "../views/vueCropper.vue";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {quillEditor,Quill} from 'vue-quill-editor';
import {ImageDrop} from "quill-image-drop-module"; // 图片拖动组件引用
import ImageResize from "quill-image-resize-module"; // 图片缩放组件引用
Quill.register("modules/imageDrop",ImageDrop); // 注册
Quill.register("modules/imageResize",ImageResize); // 注册

export default {
  name:'shopsSon',
  components:{
    vueCropper,quillEditor
  },
  data() {
    return {
      txt_keep:"发布",
      h_text:"发布商品",
      goodsId:0,
      daiGoodsType:false,
      edi_typeName:"",
      edi_typeSort:1,
      name:"",
      brief:"",
      page:1,
      pageSize:10,
      total:0,
      isCtr:true,
      edi_type:"",
      liType:[],
      liSku:[],
      pageType:1,
      pageSizeType:30,
      totalType:30,
      defHead1:[
        {'key':"规格",'val':"skuName","w":"150px",'childData':[]},
        {'key':"出售价(元)",'val':"price","w":"150px",'childData':[]},
        {'key':"原价(元)",'val':"oldPrice","w":"150px",'childData':[]},
        {'key':"库存",'val':"kuCun","w":"130px",'childData':[]},
        {'key':"规格编码",'val':"skuCode","w":"auto",'childData':[]}
      ],
      upImg:0,
      imageId:0,
      imageUrl:"",
      liImg:[],
      oldImg:[],
      url_upFile:"",
      img_w:"375px",
      img_h:"75vh",
      dialogVisible:false,
      option:{
        img:"", // 裁剪图片的地址
        info:true, // 裁剪框的大小信息
        outputSize:0.8, // 裁剪生成图片的质量
        outputType:"jpeg", // 裁剪生成图片的格式
        canScale:false, // 图片是否允许滚轮缩放
        autoCrop:true, // 是否默认生成截图框
        autoCropWidth:375, // 默认生成截图框宽度
        autoCropHeight:375, // 默认生成截图框高度
        fixedBox:false, // 固定截图框大小 不允许改变
        fixed:false, // 是否开启截图框宽高固定比例
        fixedNumber:[
          7,
          5
        ], // 截图框的宽高比例
        full:true, // 是否输出原图比例的截图
        canMoveBox:true, // 截图框能否拖动
        original:true, // 上传图片按照原始比例渲染
        centerBox:true, // 截图框是否被限制在图片里面
        infoTrue:true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      description:"",
      editorOption:{
        placeholder:"请输入需要编写的内容...",
        modules:{
          imageDrop:true, //图片拖拽
          imageResize:{
            //放大缩小
            displayStyles:{
              backgroundColor:"black",
              border:"none",
              color:"white"
            },
            modules:[
              "Resize",
              "DisplaySize",
              "Toolbar"
            ]
          },
          toolbar:[
            [
              "bold",
              "italic",
              "underline",
              "strike"
            ], // 加粗 斜体 下划线 删除线
            [
              "blockquote",
              "code-block"
            ], // 引用  代码块
            ['image'],
            [
              {header:1},
              {header:2}
            ], // 1、2 级标题
            [
              {list:"ordered"},
              {list:"bullet"}
            ], // 有序、无序列表
            [
              {script:"sub"},
              {script:"super"}
            ], // 上标/下标
            [
              {indent:"-1"},
              {indent:"+1"}
            ], // 缩进
            [{direction:"rtl"}], // 文本方向
            [
              {
                size:[
                  "12",
                  "14",
                  "16",
                  "18",
                  "20",
                  "22",
                  "24",
                  "28",
                  "32",
                  "36"
                ]
              }
            ], // 字体大小
            [
              {
                header:[
                  1,
                  2,
                  3,
                  4,
                  5,
                  6
                ]
              }
            ], // 标题
            [
              {color:[]},
              {background:[]}
            ], // 字体颜色、字体背景颜色
            // [{ font: ['songti'] }], // 字体种类
            [{align:[]}], // 对齐方式
            ["clean"], // 清除文本格式
            [
              "image",
              "video"
            ] // 链接、图片、视频
          ]
        }
      }
    };
  },
  methods:{
    onEditorBlur() {
    },
    onEditorFocus() {
    },
    onEditorReady() {
    },
    onEditorChange() {
    },
    onBack() {
      if (this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    onKeep() {
      if (this.isCtr) {
        this.isCtr = false;
        if (this.h_text === '发布商品') {
          this.keepData();
        } else {
          this.keepData();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    onAddGoodsType() {
      this.daiGoodsType = true;
    },
    onAdd() {
      if (this.liSku.length < 6) {
        this.liSku.push({id:"0",skuName:"",price:10,oldPrice:10,kuCun:10,skuCode:"123"});
      } else {
        this.$message.warning("最大只能添加6个");
      }
    },
    onDel(index) {
      this.liSku.splice(index,1);
    },
    handleDelete(index) {
      this.liImg.splice(index,1);
    },
    typeDelete(index) {
      this.$confirm(`确定要删除 "${this.liType[index].label}" 吗？`,'提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(() => {
        const params = {
          id:this.liType[index].value,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delGoodsType,params,headers).then(res => {
          console.log("delGoodsType",res.data.data);
          this.pageType = 1;
          this.pageSizeType = 30;
          this.totalType = 30;
          this.liType = [];
          this.getGoodsTypeList();
          this.$message.success("删除成功");
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("删除商品类型失败");
          }
        });
      }).catch(() => {
      });
    },
    handleUpload1() {
      if (this.liImg.length < 4) {
        this.$refs.upload1.click(); // 模拟点击文件选择按钮，触发文件选择对话框
      } else {
        this.$message.warning("详情图最大只能添加4张");
      }
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleAvatarSuccess(response) {
      console.log(response);
    },
    beforeAvatarUpload(file) {
      this.upImg = 0;
      console.log(file.type);
      //this.img_w = "375px";
      //this.img_h = "562px";
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      // 图片转为base64
      let self = this;
      const _URL = window.URL || window.webkitURL;
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      self.option.img = image.src;
      //image.onload = function () {
      //  let base64 = self.transBase64FromImage(image);
      //  self.option.img = base64;
      //};
      this.dialogVisible = true;
    },
    beforeFile1(file) {
      this.upImg = 1;
      console.log(file.type);
      //this.img_w = "375px";
      //this.img_h = "562px";
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      // 图片转为base64
      let self = this;
      const _URL = window.URL || window.webkitURL;
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      self.option.img = image.src;
      //image.onload = function () {
      //  let base64 = self.transBase64FromImage(image);
      //  self.option.img = base64;
      //};
      this.dialogVisible = true;
    },
    finish() {
      let _this = this;
      this.$refs.cropper.getCropBlob(async(data) => {
        let formData = new FormData();
        console.log(data);
        if (data) {
          var timestamp = new Date().getTime() + '.jpg';
          //  将blob格式转换为文件。File() 构造器创建新的 File 对象实例。
          const newFile = new window.File([data],timestamp);
          formData.append('file',newFile);
          formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
          // 设置请求头
          const config = {
            headers:{
              'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
              'token':localStorage.getItem("token")
            }
          };
          console.log(this.$urls.ip + this.$urls.uploadFile);
          // 使用axios或其他HTTP客户端发送请求
          if (this.upImg === 0) {
            axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
                .then(response => {
                  console.log(response.data);
                  this.imageId = response.data.data.id;
                  this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
                  this.dialogVisible = false;
                }).catch(error => {
              console.log(error);
              if (error) {
                this.$message.error(error);
              } else {
                this.$message.error("上传失败");
              }
            });
          } else {
            axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
                .then(response => {
                  console.log(response.data);
                  this.liImg.push({"id":response.data.data.id,url:this.$urls.ip + "/" + response.data.data.url});
                  this.dialogVisible = false;
                }).catch(error => {
              console.log(error);
              if (error) {
                this.$message.error(error);
              } else {
                this.$message.error("上传失败");
              }
            });
          }
        } else {
          this.$message.warning('请重新截图');
        }
      });
      _this.$forceUpdate();
    },
    keepType() {
      const params = {
        name:this.edi_typeName,
        sort:this.edi_typeSort,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addGoodsType,params,headers).then(res => {
        console.log("keepType",res.data.data);
        this.$message.success("添加成功");
        this.pageType = 1;
        this.pageSizeType = 30;
        this.totalType = 30;
        this.liType = [];
        this.getGoodsTypeList();
        this.daiGoodsType = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("添加商品类型数据失败");
        }
      });
    },
    keepData() {
      if (!this.imageId) {
        this.$message.error("请先选择产品主图");
        return;
      }
      for (let i = 0; i < this.liSku.length; i++) {
        const row = this.liSku[i];
        if (!row.skuName || row.skuName.trim() === '' ||
            row.price === null || row.price === undefined || row.price === '' ||
            row.oldPrice === null || row.oldPrice === undefined || row.oldPrice === '' ||
            row.kuCun === null || row.kuCun === undefined || row.kuCun === '' ||
            !row.skuCode || row.skuCode.trim() === '') {
          this.$message.error(`规格参数第 ${i + 1}行存在空值，请完善后再保存`);
          return;
        }
        if (!row.price || !row.oldPrice) {
          this.$message.error(`规格参数第 ${i + 1}行价格不能为0`);
          return;
        }
      }
      const params = {
        name:this.name,
        brief:this.brief,
        goodsTypeId:this.edi_type,
        goodsStateId:1,
        goodsSku:[],
        goodsBanners:[],
        iconBigId:this.imageId,
        description:this.description,
        projectId:localStorage.getItem("projectId")
      };
      if (this.txt_keep === "保存") {
        params['goodsStateId'] = 2;
      }
      for (let i = 0; i < this.liSku.length; i++) {
        var d1 = {
          "saleStartTime":"2025-12-1 00:00:00",
          "skuName":this.liSku[i]['skuName'],
          "skuCode":this.liSku[i]['skuCode'],
          "code":"1111",
          "goodsStateId":1,
          "goodsBanners":[],
          "kuCun":this.liSku[i]['kuCun'],
          "minKuCun":1,
          "saled":0,
          "skuPrice":[
            {
              price:this.liSku[i]['price'] * 100,originPrice:this.liSku[i]['oldPrice'] * 100,sort:1,
              authorityId:"5",projectId:localStorage.getItem("projectId")
            }
          ],
          "projectId":localStorage.getItem("projectId")
        };
        if (this.txt_keep === "保存") {
          d1['goodsStateId'] = 2;
        }
        if (this.liSku[i]['id'] !== '0') {
          d1['id'] = this.liSku[i]['id'];
          d1['skuPrice'][0]['id'] = this.liSku[i]['priceId'];
        }
        params['goodsSku'].push(d1);
      }
      for (let i = 0; i < this.liImg.length; i++) {
        if (this.oldImg.includes(this.liImg[i]["id"])) {
          params['goodsBanners'].push({
            id:this.liImg[i]["id"],
            urlId:this.liImg[i]["urlId"],
            name:"",
            sort:1,
            projectId:localStorage.getItem("projectId")
          });
        } else {
          params['goodsBanners'].push({
            urlId:this.liImg[i]["id"],name:"",sort:1,projectId:localStorage.getItem("projectId")
          });
        }
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      let urls = this.$urls.newGoods;
      if (this.h_text === "修改商品信息") {
        urls = this.$urls.updateGoods;
        params['id'] = this.goodsId;
      }
      console.log(params);
      this.$api.post(this.$urls.ip + urls,params,headers).then(res => {
        console.log("newGoods",res.data.data);
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("保存商品类型数据失败");
        }
      });
    },
    getGoodsTypeList() {
      if (this.pageType < this.totalType / this.pageSizeType + 1) {
        const params = {
          page:this.pageType,
          pageSize:this.pageSizeType,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.getGoodsTypeList,params,headers).then(res => {
          console.log("getGoodsTypeList",res.data.data);
          this.totalType = res.data.data.total;
          if (res.data.data.list) {
            const l_d = this.liType;
            let l = res.data.data.list;
            for (let i = 0; i < l.length; i++) {
              l_d.push({label:l[i]['name'],value:l[i]['id']});
            }
            this.liType = l_d;
            this.pageType += 1;
            this.getGoodsTypeList();
          }
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("获取商品类型数据失败");
          }
        });
      }
    },
    getGoodsInfo(goodsId) {
      const params = {
        id:goodsId,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoods,params,headers).then(res => {
        console.log("getGoodsInfo",res.data.data);
        let d = res.data.data.data;
        this.name = d.name;
        this.brief = d.brief;
        this.edi_type = d.goodsType.id;
        this.description = d.description;
        let imgs = d.goodsBanners;
        if (d["iconBig"]) {
          this.imageId = d["iconBig"]['id'];
          this.imageUrl = this.$urls.ip + "/" + d["iconBig"]["url"];
        }
        for (let i = 0; i < imgs.length; i++) {
          this.liImg.push({"id":imgs[i].id,urlId:imgs[i].urlId,url:this.$urls.ip + "/" + imgs[i].url.url});
          this.oldImg.push(imgs[i].id);
        }
        let skuS = d.goodsSku;
        for (let i = 0; i < skuS.length; i++) {
          if (skuS[i]['skuPrice'] && skuS[i]['skuPrice'].length > 0) {
            let d = {
              id:skuS[i]['id'],skuName:skuS[i]['skuName'],skuCode:skuS[i]['skuCode'],kuCun:skuS[i]['kuCun'],
              price:0,oldPrice:0,priceId:skuS[i]['skuPrice'][0]['id']
            };
            if (skuS[i]['skuPrice'][0]['price']) {
              d['price'] = skuS[i]['skuPrice'][0]['price'] / 100;
            }
            if (skuS[i]['skuPrice'][0]['originPrice']) {
              d['oldPrice'] = skuS[i]['skuPrice'][0]['originPrice'] / 100;
            }
            this.liSku.push(d);
          }
        }
        if (d["goodsStateId"] === 2) {
          this.txt_keep = "保存";
        } else {
          this.txt_keep = "发布";
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品信息失败");
        }
      });
    }
  },
  mounted() {
    const value = this.$route.query.key;
    if (value === "change") {
      this.h_text = "修改商品信息";
      this.goodsId = this.$route.query.id;
      this.getGoodsInfo(this.goodsId);
    } else {
      this.h_text = "发布商品";
    }
    this.getGoodsTypeList();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData2() {
      return this.liSku.filter(item => {
        this.state = true;
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style scoped>
.shopsSon {
  height: 94vh;
  padding: 20px;
  overflow-y: auto;
}

.box-card {
  margin-bottom: 20px;
}

.search-box {
  margin-bottom: 20px;
  display: flex;
  flex-flow: column;
  justify-items: center;
}

.option-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.option-label {
  flex: 1;
}

.delete-icon {
  color: #f56c6c;
  cursor: pointer;
  padding: 10px;
  border-radius: 4px;
  opacity: 0;
  transition: all 0.2s;
}

.delete-icon:hover {
  background-color: #fef0f0;
}

/* 鼠标悬停选项时显示删除图标 */
.el-select-dropdown__item:hover .delete-icon {
  opacity: 1;
}

.tab_adb {
  user-select: text;

  .gutter {
    /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important;
    /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}

.dialog_daiAddDev {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    background: #FFFFFF;
  }

  .el-dialog__body {
    color: #000000;
    background: #ECF0F2;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/shopsSon.vue